import { FormEvent, useState } from 'react';
import { useDispatch } from 'react-redux';

import ReactCodeInput from 'react-code-input';
import { RouteComponentProps } from 'react-router';
import { useAppSelector } from '../../app/hooks';
import Spinner from '../../components/common/Spinner';
import { P2, P3 } from '../../styles/FontStyles';
import {
  AuthLayoutTitle,
  Button,
  Flexed,
  SecurityCodeWrapper
} from '../../styles/GlobalComponents';
import { colors } from '../../styles/GlobalStyles';
import { sendSecurityCode } from './SecurityCode.actions';
import { InputBackOffice } from '../../components/common/InputBackoffice';
import { verifySignIn } from '../../slices/auth-slice';
import { Label } from '../../styles/stylesStyled';
import { validateEmail } from '../../helpers/helperFunctions';
import { ErrorToast } from '../../components';

const captchaId = process.env.REACT_APP_CAPTCHA_ID;

const SecurityCode = ({ history }: RouteComponentProps) => {
  const [code, setCode] = useState('');
  const [email, setEmail] = useState('');
  const [captchaLoading, setCaptchaLoading] = useState(false);

  const dispatch = useDispatch();
  const { register, loading } = useAppSelector((state) => state.auth);

  const onHandleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setCaptchaLoading(true);
    window?.initGeetest4(
      {
        captchaId,
        language: 'eng',
        product: 'bind',
        riskType: 'slide',
        nativeButton: {
          width: '100%',
          marginBottom: '20px'
        }
      },
      function (captcha: any) {
        captcha.showBox();
        captcha
          .onReady(function () {
            setCaptchaLoading(false);
          })
          .onSuccess(function () {
            const validate = captcha.getValidate();

            if (validateEmail(email)) {
              dispatch(
                sendSecurityCode({
                  result: validate,
                  code,
                  email: register?.user?.email,
                  history
                })
              );
            } else {
              ErrorToast('Please enter a valid email');
            }
          })
          .onError(function () {
            setCaptchaLoading(false);
          });
      }
    );
  };

  const sendVerificationCode = () => {
    setCaptchaLoading(true);
    window?.initGeetest4(
      {
        captchaId,
        language: 'eng',
        product: 'bind',
        riskType: 'slide',
        nativeButton: {
          width: '100%',
          marginBottom: '20px'
        }
      },
      function (captcha: any) {
        captcha.showBox();
        captcha
          .onReady(function () {
            setCaptchaLoading(false);
          })
          .onSuccess(function () {
            const validate = captcha.getValidate();

            dispatch(
              verifySignIn({
                result: validate,
                email,
                history
              })
            );
          })
          .onError(function () {
            setCaptchaLoading(false);
          });
      }
    );
  };

  const Required = () => {
    return <span style={{ color: colors.error500, marginLeft: 2 }}>*</span>;
  };

  return (
    <>
      {(loading || captchaLoading) && <Spinner fullScreen={true} transparent />}
      <Flexed column>
        <AuthLayoutTitle>Sign In with email</AuthLayoutTitle>

        <form onSubmit={onHandleSubmit}>
          <>
            <Label>
              Email
              <Required />
            </Label>
            <InputBackOffice
              id={'id'}
              type={'text'}
              placeholder={'Email address'}
              name={'email'}
              value={email.replace(/\s+/g, '')}
              onChange={(e: any) => setEmail(e.replace(/\s+/g, ''))}
              label={'Email'}
              style={{ textTransform: 'lowercase' }}
            />

            <Flexed between>
              <P2 bold color={colors.neutral700}>
                Email verification code <Required />
              </P2>
              <P2
                bold
                style={{ cursor: email ? 'pointer' : 'default' }}
                color={email ? colors.primary900 : colors.neutral400}
                onClick={() => {
                  if (validateEmail(email)) {
                    sendVerificationCode();
                  } else {
                    ErrorToast('Please enter a valid email');
                  }
                }}>
                Send Code
              </P2>
            </Flexed>
            <SecurityCodeWrapper>
              <ReactCodeInput
                name='security-code'
                fields={7}
                value={code}
                onChange={setCode}
                type={'number'}
                inputMode='numeric'
              />
            </SecurityCodeWrapper>
            {register?.user?.email ? (
              <P3 color={colors.neutral500} mb='10'>
                {`Enter the 7 digit code sent to ${register?.user?.email}`}
              </P3>
            ) : (
              <P3 color={colors.neutral0} mb='10'>
                ''
              </P3>
            )}
          </>

          <Button m='30px 0 10px 0' disabled={code.length < 7}>
            Sign In
          </Button>
        </form>
      </Flexed>
    </>
  );
};

export default SecurityCode;
